// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__87FJT","calendarButtons":"ClockData_calendarButtons__LzH5Q"};